const styles = {
  form: {
    pt: 1.5,
    pr: 1,
    pb: 1
  },
  formActions: {
    mt: 2
  },
  actionButton: {
    textTransform: 'none'
  }
};

export default styles;
